import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { SMS_TEMPLATE_CONTROLLER } from "api/Service";

export const useSmsTemplates = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["smsTemplatesAll", tenantVal, patientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const url = patientId
        ? `${tenantVal}${SMS_TEMPLATE_CONTROLLER}?patientId=${patientId}`
        : `${tenantVal}${SMS_TEMPLATE_CONTROLLER}`;
      const response = await axiosInstance.get(url);

      return response.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};
